import { Chip, Grid, User } from '~components';
import * as Styled from './styled';
import { Props } from './types';
import mobile from 'is-mobile';
import { FuelTypography } from '@frete.com/fuel-react';

function Header({
  isPrimaryRepresentant,
  isFormPendent,
  isCardExpanded,
  name,
}: Props) {
  const isMobile = mobile();
  const subtitle = isFormPendent
    ? `Informações do representante ${!isMobile ? 'legal' : ''}`
    : name;

  return (
    <Styled.Container
      $hasSpacingDown={isFormPendent || isCardExpanded}
      $isPrimaryRepresentant={isPrimaryRepresentant}
    >
      <Grid container spacing={4}>
        <Grid xs={1}>
          <User />
        </Grid>
        <Grid xs={11}>
          <Grid container direction="column" spacing={4}>
            <Grid container align="center" spacing={4}>
              <Grid>
                <FuelTypography size="body-md" color="neutral-default">
                  Representante legal
                </FuelTypography>
              </Grid>
              <Grid>
                {!isMobile &&
                  (isFormPendent ? (
                    <Chip type="warning">PENDENTE</Chip>
                  ) : (
                    <Chip type="success">CONCLUÍDO</Chip>
                  ))}
              </Grid>
            </Grid>
            <Grid>
              <FuelTypography variant="bold">{subtitle}</FuelTypography>
            </Grid>
            {isMobile && (
              <Grid>
                {isFormPendent ? (
                  <Chip type="warning">PENDENTE</Chip>
                ) : (
                  <Chip type="success">CONCLUÍDO</Chip>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Styled.Container>
  );
}

export default Header;
